/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import {
  ApiBasedService,
  ListItemResource,
  ListResource,
  ListResourceServiceConfig,
  ResourceServiceConfig,
  StateResource,
} from '@common/tech-shared';
import { UserProfileLinkRel, UserProfileResource, UserProfileService } from '@alfa-client/user-profile-shared';
import { inject, Injectable } from '@angular/core';
import { Resource } from '@ngxp/rest';
import { Observable } from 'rxjs';
import { UserSettingsLinkRel } from './user-settings.linkrel';
import { UserSettings, UserSettingsResource } from './user-settings.model';

@Injectable({ providedIn: 'root' })
export class UserSettingsService extends ApiBasedService<
  UserProfileResource,
  UserSettingsResource,
  Resource,
  ListResource,
  ListItemResource,
  UserSettings
> {
  getResourceConfig(): ResourceServiceConfig<UserProfileResource> {
    const userProfileService = inject(UserProfileService);
    return {
      baseResource: userProfileService.getCurrentUser(),
      getLinkRel: UserProfileLinkRel.SETTINGS,
      edit: { linkRel: UserSettingsLinkRel.EDIT },
    };
  }

  getListResourceConfig(): ListResourceServiceConfig<Resource> {
    return undefined;
  }

  getFeatureName(): string {
    return 'UserSettings';
  }

  public getUserSettings(): Observable<StateResource<UserSettingsResource>> {
    return this.get();
  }

  public setUserSettings(userSettings: UserSettings): void {
    this.save(userSettings).subscribe();
  }
}
